import http from "../http-common";

class LatestCoursesService {
  getLatestCourses(numberOfProducts: number) {
    return http.get(`/products/courses/latest?noOfProducts=${numberOfProducts.toString()}`);
  }
}

export default new LatestCoursesService();
